export default {"src":"/_next/static/image/public/img/icons/globe.9734705ad9157517941ba3015ff89990.svg","height":20,"width":20};